import { createContext } from 'react';
import { IGames } from 'types';

export type TGamesSortBy =
	| ''
	| 'NameA-Z'
	| 'NameZ-A'
	| 'ApplicationIdA-Z'
	| 'ApplicationIdZ-A'
	| 'VersionCode1-10'
	| 'VersionCode10-1'
	| 'VersionName1-10'
	| 'VersionName10-1'
	| 'CategoriesA-Z'
	| 'CategoriesZ-A';
export type TGamesCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	selectedDeveloper: Nullable<string>;
	selectedCategory: Nullable<string>;
	isUnassignedGames: boolean;
	sortBy: TGamesSortBy;
	countOfItems: TGamesCountOfItems;
	currentPage: number;
}

export interface IGamesState {
	games: IGames;
	searchString: string;
	selectedDeveloper: Nullable<string>;
	selectedCategory: Nullable<string>;
	isUnassignedGames: boolean;
	sortBy: TGamesSortBy;
	countOfItems: TGamesCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const gamesInitialState: IGamesState = {
	games: { gamesCount: 0, games: [] },
	searchString: '',
	selectedDeveloper: null,
	selectedCategory: null,
	isUnassignedGames: false,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	typeOfModalWindow: null,
};

export interface IGamesContext extends IGamesState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setDeveloper(value: Nullable<string>): void;
	setCategory(value: Nullable<string>): void;
	resetSelectedControls(): void;
	toggleUnassignedGames(): void;
	setSortBy(sortBy: TGamesSortBy): void;
	setCountOfItems(count: TGamesCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const GamesContext = createContext<IGamesContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	setDeveloper: () => undefined,
	setCategory: () => undefined,
	resetSelectedControls: () => undefined,
	toggleUnassignedGames: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...gamesInitialState,
});
